module.exports = __webpack_public_path__ + "img/medical.310dc2c6.png";